import { Injectable } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { lastValueFrom } from "rxjs";
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationInitializerService {
  scopes: string[] = [];
  constructor(private authService: CalAngularService) { }

  async checkAccount() : Promise<boolean> {
     

   
    const isUserLoggedIn = await lastValueFrom(this.authService.isUserSignedIn())

    if(isUserLoggedIn.valueOf()) {
        let currentUserProfile = this.authService.cvxClaimsPrincipal; 
    }
     return isUserLoggedIn;
  }

  async getCALAccessToken() {
     
    this.scopes = environment.calConfig.oidcScopes;
    const accessToken = await lastValueFrom(this.authService.getAADToken(this.scopes));
    return accessToken
  }
}
